import { ChevronIcon } from '@ardoq/icons';
import styled from 'styled-components';
import { GremlinObjectType } from '../types';
import { ComponentOverviewLink } from 'components/ComponentOverviewLink/ComponentOverviewLink';

const PathWrapper = styled.span`
  line-height: 25px;

  strong {
    padding-left: 5px;
  }

  svg {
    padding: 0 5px;
    font-size: 20px;
    vertical-align: middle;
  }
`;

const ArrowSign = (props: { printable?: boolean }) =>
  props.printable ? <>{' -> '}</> : <ChevronIcon direction="right" />;

interface GremlinPathProps {
  pathLabels: {
    id: string;
    name: string;
    label: string;
    type: GremlinObjectType;
  }[];
  printable?: boolean;
}
const GremlinPath = (props: GremlinPathProps) => (
  <PathWrapper>
    {props.pathLabels.map(({ id, name, label, type }, index: number) => {
      const showArrow = index < props.pathLabels.length - 1;

      if (type === GremlinObjectType.EDGE) {
        return (
          <span key={index}>
            <em>{label}</em>
            {showArrow && <ArrowSign printable={props.printable} />}
          </span>
        );
      }
      return (
        <span key={index}>
          {label}:
          <ComponentOverviewLink componentId={id}>
            <strong>{name}</strong>
          </ComponentOverviewLink>
          {showArrow && <ArrowSign printable={props.printable} />}
        </span>
      );
    })}
  </PathWrapper>
);

export { GremlinPath };
